/*
 * Copyright 2023 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { EntityMatcherFn } from './types';

/**
 * Matches on spec.type
 */
export function createTypeMatcher(
  parameters: string[],
  _onParseError: (error: Error) => void,
): EntityMatcherFn {
  const items = parameters.map(p => p.toLocaleLowerCase('en-US'));
  return entity => {
    const value = entity.spec?.type;
    return (
      typeof value === 'string' &&
      items.includes(value.toLocaleLowerCase('en-US'))
    );
  };
}
